import "swiper/swiper-bundle.min.css";
import SwiperCore, { Autoplay } from "swiper";
SwiperCore.use([Autoplay]);

export * from "swiper/react";
